import React from "react";
import { Button } from "../../../designSystem/button/Button";

export function InstructionText({text, defaultCollapsed}:{text:string, defaultCollapsed?:boolean}): JSX.Element
{
    const [collapsed, setCollapsed] = React.useState(defaultCollapsed);

    React.useEffect(()=>{
        setCollapsed(defaultCollapsed);        
    }, [defaultCollapsed]);


    const indexOfBreak = text.indexOf('\n\n');
    const smallText = indexOfBreak > 0 ? text.substring(0, indexOfBreak) : text;
    const remainingText = indexOfBreak > 0 ? text.substring(indexOfBreak+1) : '';

    return (
        <div style={{whiteSpace:'pre-wrap'}}>
            {smallText}
            {!collapsed && <span><br />{remainingText}</span>}
            {indexOfBreak > 0 && 
                <>
                    <br />
                    <Button onClick={() => setCollapsed(!collapsed)} text={collapsed ? '...vis mere' : '...vis mindre'} variant={"text"} />
                </>
            }
        </div>
    );
}